import React from 'react'
import PropTypes from 'prop-types'
import {
  WhiteSpace,
  StyledLanguages,
  StyledLanguageItem,
  LocalesContainer,
} from './LocalesTab.styled'
import LocalesMacher from '../../interfaces/LocalesMatcher'
import UrlFactory from '../../utils/UrlFactory'
import { languageButtonEvent } from '../../utils/gtmEvents'

export const templateEnum = Object.freeze({
  product: 'product',
  location: 'location',
})

const LocalesTab = ({ locales, slug, slugs, template, pageCategory }) => {
  const getUrl = (locale) => {
    if (template === templateEnum.product) {
      const productTitle = slugs?.find((el) => el.locale === locale).slug
      return UrlFactory.getForeignProductUrl(locale, productTitle)
    }

    if (template === templateEnum.location)
      return UrlFactory.getForeignLocationUrl(locale, slug)
  }

  const sortedLocales = locales.sort((a, b) =>
    LocalesMacher[a].localeCompare(LocalesMacher[b])
  )

  return (
    <LocalesContainer>
      <WhiteSpace />
      <StyledLanguages>
        {sortedLocales.map((locale, index) => (
          <StyledLanguageItem
            href={getUrl(locale, slug)}
            onClick={() =>
              languageButtonEvent({
                pageCategory,
                ctaName: 'language',
                language: LocalesMacher[locale],
              })
            }
            key={index}
            target="_blank"
            rel="noreferrer"
          >
            {LocalesMacher[locale]}
          </StyledLanguageItem>
        ))}
      </StyledLanguages>
    </LocalesContainer>
  )
}

LocalesTab.propTypes = {
  locales: PropTypes.array.isRequired,
}

export default LocalesTab
